import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'coerceBoolean' })
export class CoerceBooleanPipe implements PipeTransform {
  public transform(value: any): boolean {
    if (typeof value === 'boolean') {
      return value;
    }
    if (typeof value === 'string') {
      return ['true', 'yes', 'on', '1'].includes(value.trim().toLowerCase());
    }
    return ![null, undefined, 0, '0', '', NaN, false, 'false', 'no', 'off'].includes(value);
  }
}